import { render, staticRenderFns } from "./userservice_v3.vue?vue&type=template&id=53594563&scoped=true&"
import script from "./userservice_v3.vue?vue&type=script&lang=js&"
export * from "./userservice_v3.vue?vue&type=script&lang=js&"
import style0 from "./userservice_v3.vue?vue&type=style&index=0&id=53594563&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53594563",
  null
  
)

export default component.exports